<script setup lang="ts">
import type { Component, HTMLAttributes } from 'vue';
import HeaderInfoTooltip from '@/components/workspace/HeaderInfoTooltip.vue';
import { cn } from '@/lib/utils';

const props = withDefaults(defineProps<{
    title: string;
    description?: string;
    icon?: Component | null;
    headingLevel?: 1 | 2 | 3;
    class?: HTMLAttributes['class'];
    titleClass?: HTMLAttributes['class'];
    actionsClass?: HTMLAttributes['class'];
}>(), {
    description: '',
    icon: null,
    headingLevel: 2,
    class: '',
    titleClass: '',
    actionsClass: '',
});

const headingTag = computed<'h1' | 'h2' | 'h3'>(() => `h${props.headingLevel}` as 'h1' | 'h2' | 'h3');
</script>

<template>
    <div :class="cn('flex min-w-0 flex-wrap items-center justify-between gap-3', props.class)">
        <div class="flex min-w-0 items-center gap-2">
            <span v-if="icon" class="inline-flex size-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                <component :is="icon" class="size-4" />
            </span>
            <component
                :is="headingTag"
                :class="cn('app-section-subtitle min-w-0', props.titleClass)"
            >
                {{ title }}
            </component>
            <HeaderInfoTooltip
                v-if="description"
                :description="description"
                :label="`About ${title}`"
            />
            <slot name="badges" />
        </div>

        <div v-if="$slots.actions" :class="cn('flex shrink-0 flex-wrap items-center gap-2', props.actionsClass)">
            <slot name="actions" />
        </div>
    </div>
</template>
